import { gql } from "@apollo/client";

export const PLAN_INFO = gql`
  query queryPLan($id: Float!) {
    plan(id: $id) {
      id
      name
      value
      requests
      description
      monthly
      passenger
      franchise_id
      acting_region_id
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
      is_actived
    }
  }
`;

export const PLANS = gql`
  query queryPlans($franchise_id: Float, $acting_region_id: Float) {
    plans(franchise_id: $franchise_id, acting_region_id: $acting_region_id) {
      id
      name
      value
      requests
      description
      monthly
      passenger
      franchise_id
      acting_region_id
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
      is_actived
    }
  }
`;

export default PLAN_INFO;
